// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:24:57

export default {
  "id": "shelf-shift-match",
  "slug": "shelf-shift-match",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d677b28414fb4a69a13ed9ee99e30865-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d677b28414fb4a69a13ed9ee99e30865/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Shelf Shift Match",
      "description": "Test your strategy and speed in Shelf Shift Match! Shift items on the shelves to create perfect matches of three, clearing the way to reveal hidden shadowed items. But beware—unwise moves can block your shelves, leaving no space to shift and leading to game over! If you're stuck, use the shuffle button to mix things up and find new matches. ",
      "instructions": "Use a mouse or touchpad to play this game.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "hidden",
        "matching",
        "skill",
        "sorting",
        "supermarket"
      ]
    },
    "zh-CN": {
      "title": "货架换位匹配",
      "description": "在《货架移位匹配》中测试你的策略和速度！在货架上移动物品以创建三个完美匹配，清除道路以揭示隐藏的阴影物品。但小心——不智的举动可能会阻塞你的货架，留下没有空间移动，导致游戏结束！如果你卡住了，使用洗牌按钮来打乱顺序，找到新的匹配。",
      "instructions": "使用鼠标或触摸板来玩这款游戏。",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "隐藏",
        "匹配",
        "技能",
        "排序",
        "超市"
      ]
    },
    "zh-TW": {
      "title": "書架移位配對",
      "description": "測試你的策略和速度在《架位移位匹配》！將架上物品移位以創造三個相同的匹配，清空道路以揭露隱藏的影子物品。但小心—不明智的移動可能會阻塞你的架子，留下沒有移位的空間，導致遊戲結束！如果你卡住了，使用洗牌按鈕來打亂局勢，找到新的匹配。",
      "instructions": "使用滑鼠或觸控板來玩這款遊戲。",
      "genres": [
        "配對3"
      ],
      "tags": [
        "隱藏",
        "配對",
        "技能",
        "排序",
        "超市"
      ]
    },
    "zh-HK": {
      "title": "書架移動配對",
      "description": "測試你的策略和速度在《架位移動配對》！移動架上物品，創造三個相同的完美配對，清空道路以揭露隱藏的影影綽綽物品。但小心——不明智的移動可以阻塞你的架位，留不出移動空間，導致遊戲結束！如果你陷入困境，使用洗牌按鈕混亂事物，找到新的配對。",
      "instructions": "使用鼠標或觸控板玩遊戲。",
      "genres": [
        "三消遊戲"
      ],
      "tags": [
        "隱藏",
        "配對",
        "技能",
        "排序",
        "超市"
      ]
    },
    "ja": {
      "title": "シェルフシフトマッチ",
      "description": "シェルフシフトマッチであなたの戦略とスピードを試してみてください！棚のアイテムをシフトして、三つ合わせて完璧なマッチを作り、隠された影のアイテムを明かす道を開きます。しかし、不注意な動きは棚を塞ぎ、シフトする空間がなくなり、ゲームオーバーにつながることを注意してください。もし迷ったら、シャッフルボタンを使ってアイテムを混ぜ合わせて新しいマッチを見つけましょう。",
      "instructions": "マウスやタッチパッドを使用してこのゲームを遊んでください。",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "隠し",
        "一致",
        "スキル",
        "並べ替え",
        "スーパーマーケット"
      ]
    },
    "ko": {
      "title": "셀프시프트 매치",
      "description": "셀프쉐프 매치에서 전략과 속도를 테스트해보세요! 쇼파이프 위의 아이템을 이동하여 세 개의 완벽한 매치를 만들어 숨겨진 은은한 아이템을 드러내세요. 하지만 주의하세요—비이성적인 움직임은 쇼파이프를 막아서 이동 공간이 없게 되고, 게임이 끝납니다! 막혔을 때, 셔플 버튼을 사용하여 아이템을 섞어 새로운 매치를 찾으세요.",
      "instructions": "이 게임을 플레이하기 위해 마우스나 터치패드를 사용하세요.",
      "genres": [
        "매치3"
      ],
      "tags": [
        "숨겨진",
        "매칭",
        "기술",
        "정렬",
        "슈퍼마켓"
      ]
    },
    "fr": {
      "title": "Mouvement d'Étagère Concours",
      "description": "Testez votre stratégie et votre rapidité dans Shelf Shift Match ! Déplacez les articles sur les étagères pour créer des combinaisons parfaites de trois éléments, en libérant ainsi la voie pour révéler des articles ombrés cachés. Mais faites attention — des mouvements imprudents peuvent bloquer vos étagères, laissant pas d'espace pour déplacer et conduisant à la fin de la partie ! Si vous êtes bloqué, utilisez le bouton shuffle pour mélanger les choses et trouver de nouvelles combinaisons.",
      "instructions": "Utilisez une souris ou un pavé tactile pour jouer à ce jeu.",
      "genres": [
        "Trios de cartes"
      ],
      "tags": [
        "caché",
        "correspondance",
        "compétence",
        "tri",
        "supermarché"
      ]
    }
  }
};
